'use client';

var translations = {
    'Job Title': 'Chức danh',
    Phone: 'Điện thoại',
    'Cover letter': 'Thư giới thiệu',
    Optional: 'Không bắt buộc',
    'Enter job title': 'Nhập chức danh',
    'Enter phone number': 'Nhập số điện thoại',
    'Enter cover letter': 'Nhập thư giới thiệu',
    'View sample': 'Xem mẫu thư giới thiệu',
    'Choose a profile to apply': 'Chọn hồ sơ ứng tuyển',
    'Please upload your attached CV to apply': 'Vui lòng đính kèm CV của bạn để ứng tuyển',
    'Upload your attached CV to apply': 'Đính kèm CV của bạn để ứng tuyển',
    'Employers prefer to receive your resume in': 'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng',
    'Allow Employers to search': 'Cho phép Nhà tuyển dụng tìm kiếm',
    'VietnamWorks Profile': 'Hồ Sơ VietnamWorks',
    'Create attracted CV with WowCV': 'Tạo hồ sơ ấn tượng với WowCV',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'This is not a valid URL.': 'Đường dẫn không hợp lệ.',
    'This is not a valid number.': 'Số không hợp lệ.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    'Attached CV': 'Hồ Sơ Đính Kèm',
    'CV Just Uploaded': 'Hồ Sơ Vừa Tải Lên',
    'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:': 'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:',
    'Not enough information to use the function Allow Employers to search attached CV. Update information at': 'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại',
    'Profile settings': 'Thiết lập hồ sơ',
    'my-profile': 'ho-so',
    'profile-settings': 'thiet-lap-ho-so',
    'my-career-center': 'quan-ly-nghe-nghiep',
    Updated: 'Đã cập nhật',
    Uploaded: 'Đã tải lên',
    Update: 'Cập nhật',
    'Update profile': 'Cập nhật',
    'VietnamWorks online Profile': 'Hồ sơ online VietnamWorks',
    Resume: 'Resume',
    View: 'Xem',
    'View CV': 'Xem hồ sơ',
    Any: 'Bất kỳ',
    completed: 'hoàn thiện',
    'By Vietnamworks profile': 'Bằng hồ sơ Vietnamworks',
    'By attached CVs': 'Bằng hồ sơ đính kèm',
    'Cancel': 'Huỷ',
    'Just uploaded': 'Vừa tải lên',
    'Not approved': 'Chưa được duyệt',
    'preview-resume/': 'xem-truoc-ho-so/',
    'View as employer': 'Xem như nhà tuyển dụng',
};

export { translations as default };
//# sourceMappingURL=translations.js.map
